import { TutorProfile } from "../../components/settings/tutorProfile"
import { TutorEducation } from "../../components/settings/tutorEducation"
import { TutorExperience } from "../../components/settings/tutorExperience"
import { TutorCertificates } from "../../components/settings/tutorCertificates"
import { Toaster } from "react-hot-toast"

const ProfileSettings = () => {
    return (
        <>
            <Toaster />
            <div className="mx-auto w-full lg:w-3/4 xl:w-3/4">
                <TutorProfile />
                <TutorEducation />
                <TutorExperience />
                <TutorCertificates />
            </div>
        </>
    )
}

export { ProfileSettings }